import { Link } from '@solidjs/meta';

export function Sora()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap' rel='stylesheet' />
	</>);
}

